<template>
  <!--设备使用比例-->
  <div class="CampusRank"  :style="{'height':height+'px'}">
    <div class="titlegaga">设备类型消费饼状图(本年)  单位:万元</div>
    <div id="PieYear"></div>
  </div>
</template>
  
  <script>
  import G2 from '@antv/g2';

export default {
  name: 'PieYear',
  props: ['data','height'],
  data() {
    return {
      chart: null,
    };
  },
  methods: {
    initChart() {
      if (!this.chart) {
        this.chart = new G2.Chart({
          container: 'PieYear',
          forceFit: true,
          padding:10,
          height: window.outerHeight / 4,
        });
        this.chart.source(this.data, {
          percent: {
            formatter: function formatter(val) {
              val = (val * 100).toFixed(0) + '%';
              return val;
            },
          },
        });
        this.chart.coord('theta', {
          radius: 0.75,
          innerRadius: 0.6
        });
        this.chart.legend(false);
        this.chart.tooltip({
          showTitle: false,
        });
        this.chart
          .intervalStack()
          .position('percent')
          .color('item')
          .label('percent', {
            // autoRotate: false,
            offset:24,
            textStyle: {
              // textAlign: 'center',
              shadowBlur: 2,
              shadowColor: 'rgba(0, 0, 0, .45)',
              fill:'#fff',
              fontSize:window.outerWidth/1936*16
            },
            formatter: function formatter(val, item) {
              return item.point.item+' '+ val+ ' \n'+item.point.money;
            }
          })
          .tooltip('item*percent*money', function (item, percent,money) {
            percent =(percent * 100).toFixed(0) + '%'+money;
            return {
              name: item,
              value: percent,
              money:money
            };
          })
          .style({
            lineWidth: 1,
            stroke: '#fff',
          });
        this.chart.render();
      } else {
        this.chart.changeData(this.data);
      }
    },
  },
};
</script>
  
  <style lang="scss">
.CampusRank {
  position: relative;
  height: 100%;
  .CampusRank-title {
    font-size: 16px;
    text-align: center;
    padding-bottom: 12px;
  }
  .CampusRank-legend {
    position: absolute;
    width: 160px;
    transform: translateY(-50%);
    line-height: 30px;
    top: 50%;
    right: 0;
  }
  .g2-legend-text {
    display: inline-block;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
  .g2-legend-price {
    display: inline-block;
    width: 90px;
    text-align: right;
  }
}
#PieYear{
  height:calc(100% - 2vw);
}
</style>
  